/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_DifficultyInputs */

const en_us2_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How hard was it, from 1 to 5?`)
};

const pt_br2_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual foi a dificuldade, de 1 a 5?`)
};

const es_419_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan difícil fue, del 1 al 5?`)
};

const pt_pt2_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual foi a dificuldade, de 1 a 5?`)
};

const fr_fr2_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'était dur à quel point, de 1 à 5 ?`)
};

const de_de2_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schwer war es, von 1 bis 5?`)
};

const it_it2_workout_after_difficulty = /** @type {(inputs: Workout_After_DifficultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è stato difficile, da 1 a 5?`)
};

/**
* | output |
* | --- |
* | "How hard was it, from 1 to 5?" |
*
* @param {Workout_After_DifficultyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_difficulty = /** @type {((inputs?: Workout_After_DifficultyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_DifficultyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_difficulty(inputs)
	if (locale === "es-419") return es_419_workout_after_difficulty(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_difficulty(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_difficulty(inputs)
	if (locale === "de-DE") return de_de2_workout_after_difficulty(inputs)
	if (locale === "it-IT") return it_it2_workout_after_difficulty(inputs)
	return en_us2_workout_after_difficulty(inputs)
});
export { workout_after_difficulty as "workout-after.difficulty" }